import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { SingleDataStore } from "../../../../../Shared/Stores/SingleDataStore";
import { SingleDataStoreDispacher } from "../../../../../Shared/Stores/SingleDataStoreDispacher";

export const NoChangeToolDisaptcher: SingleDataStoreDispacher<
    GiaContributionModel | IsaContributionModel
> = new SingleDataStoreDispacher<GiaContributionModel | IsaContributionModel>();

export const NoChangeToolStore: SingleDataStore<GiaContributionModel | IsaContributionModel> = new SingleDataStore<
    GiaContributionModel | IsaContributionModel
>(NoChangeToolDisaptcher);
